module.exports = __webpack_public_path__ + "media/images/icons/chart-line-95c3f4b5aaec3c0c689f26cffdf217fe.svg";